<app-loader *ngIf="Loader"></app-loader>

<div class="main p-5">
    <div class="w-full">
        <div class="flex justify-between items-center mx-5 my-2">
            <span class="font-semibold text-xl text-slate-800 mb-5">Product Bulk Upload</span>
            <div class="flex gap-2 items-center">
                <img src="/assets/images/excel.png" class="h-7" alt="Excel Icon">
                <a href="/assets/excel/surplustek_registration.xlsx" download
                    class="text-sm hover:text-light-primary font-medium px-2 py-1">
                    Download Sample File
                </a>
            </div>
        </div>
    </div>

    <div class="w-full px-5 my-5">
        <form class="create-accountForm" [formGroup]="UploaditemformGroup" (ngSubmit)="onSubmit()" autocomplete="off">
            <div class="lg:p-10 p-4 shadow-xl border rounded-lg">

                <div class="lg:flex gap-5 justify-between w-full">
                    <div class="lg:flex gap-4 lg:w-1/4 items-center">
                        <label class="lg:w-44 lg:text-right">Register as Buyer</label>
                        <select
                            class="custom-dropdown bg-neutral-100 text-sm border-none rounded-md text-gray-600 focus:ring-1 focus:ring-gray-400 placeholder:text-gray-400 lg:w-32"
                            (change)="Selecttype($event)" disabled>
                            <option value="1" selected> Buyer </option>
                            <option value="2"> Seller </option>
                        </select>
                    </div>
                    <div class="lg:flex gap-4 lg:w-3/4 items-center">
                        <label class="lg:w-44 lg:text-right">Register For</label>
                        <div class="align w-full">
                            <ng-multiselect-dropdown name="register_for" formControlName="register_for"
                                class="custom-dropdown bg-neutral-100 text-sm text-gray-600 focus:ring-1 focus:ring-gray-400 placeholder:text-gray-400"
                                [placeholder]="'Select'" [settings]="registerforSettings" [data]="buyers_ary"
                                (onSelect)="registerforSelect($event)" [placeholder]="'Select'">
                            </ng-multiselect-dropdown>
                        </div>
                    </div>
                </div>


                <div class=" mt-3">
                    <div class="">
                        <label for="id_cateloge"
                            class="flex flex-col items-center justify-center w-full rounded-lg cursor-pointer bg-gray-100 mt-3 py-5">
                            <div class="flex justify-center gap-3">
                                <div class="flex justify-center items-center gap-3">
                                    <!-- <span class="bg-gray-300 p-5"> -->
                                    <span
                                        class="text-2xl font-bold bg-gray-300 px-4 py-1 opacity-50 rounded-lg">+</span>
                                    <!-- </span> -->
                                </div>
                                <div>
                                    <span class="text-sm text-left font-semibold text-gray-600">Upload File</span>
                                    <div class="text-xs text-left font-medium text-gray-400 my-1">
                                        File Types : xlsx, xls
                                    </div>
                                    <div class="text-xs text-left font-medium text-red-400">
                                        Maximum 2 MB
                                    </div>
                                </div>
                            </div>
                            <input type="file" id="id_cateloge" class="hidden" (change)="onFileChange($event)"
                                accept=".xlsx, .xls" name="read_excel_data" formControlName="read_excel_data"
                                placeholder="choose file"
                                [ngClass]="{'error-border' : UploaditemformGroup.get('read_excel_data')?.touched && UploaditemformGroup.get('read_excel_data')?.invalid}">

                        </label>

                        <div *ngIf="UploaditemformGroup.get('read_excel_data')?.touched && UploaditemformGroup.get('read_excel_data')?.invalid"
                            class="text-red-500 text-right text-xs mt-1 pl-30">
                            <div *ngIf="UploaditemformGroup.get('read_excel_data')?.errors?.['required']">Please select
                                a valid option.</div>
                        </div>
                    </div>

                    <div class="text-center pt-4">
                        <button id="btn_preview"
                            class="mx-3 bg-primary-bg hover:bg-secondary-bg focus:bg-primary-bg text-white rounded-lg px-5 py-2 font-semibold"
                            type="submit" [disabled]="errorMessages.length > 0 || users.length === 0">
                            Submit
                        </button>
                    </div>

                    <div *ngIf="errorMessages.length > 0" class="errors">
                        <hr class="my-5" />
                        <ul>
                            <li *ngFor="let error of errorMessages" class="text-red-500">{{ error }}</li>
                        </ul>
                    </div>

                    <div class="max-h-96 overflow-auto shadow-xl rounded-lg mt-4">
                        <table *ngIf="users.length > 0" class="table w-full">
                            <thead class="sticky top-0 bg-gray-300 py-4">
                                <tr>
                                    <th class="p-4">S.No</th>
                                    <th class="p-4">Buyer Type</th>
                                    <!-- <th class="p-4">GST Included</th> -->
                                    <th class="p-4">GST Number</th>
                                    <th class="p-4">Company Name</th>
                                    <th class="p-4">Vendor Code</th>
                                    <th class="p-4 text-left">Person Name</th>
                                    <th class="p-4">Mobile Number</th>
                                    <th class="p-4 text-left">Mail Id</th>
                                    <th class="p-4 text-left">Industry</th>
                                    <th class="p-4 text-left">Country</th>
                                    <th class="p-4 text-left">Region</th>
                                    <!-- <th class="px-4">T&C</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let user of users; let i = index">
                                    <td class="p-3 text-center">{{i+1}} </td>
                                    <td class="p-3 text-center">{{user.Buyer_Type}} </td>
                                    <!-- <td class="p-3 text-center">{{user.GST_included}} </td> -->
                                    <td class="p-3 text-center">{{user.GST_Number}} </td>
                                    <th class="p-4">{{user.Company_Name}} </th>
                                    <td class="p-3 text-center">{{user.Vendor_Code}} </td>
                                    <td class="p-3  max-w-44">{{user.Contact_Person_Name}} </td>
                                    <td class="p-3 text-center">{{user.Mobile_Number}} </td>
                                    <td class="p-3 max-w-44 break-all">{{user.Mail_Id}} </td>
                                    <td class="p-3">{{user.Industry}} </td>
                                    <td class="p-3">{{user.Country}} </td>
                                    <td class="p-3">{{user.Region}} </td>
                                    <!-- <td class="p-3">{{user.Terms_Condition}} </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </form>
    </div>
</div>